var _style, _defs, _g, _defs2, _g2, _defs3, _g3, _defs4, _g4, _defs5, _g5, _defs6, _g6, _defs7, _g7, _defs8, _g8, _defs9, _g9, _defs10, _g10, _defs11, _g11, _path, _defs12, _g12, _defs13, _g13, _defs14, _g14, _defs15, _g15, _defs16, _g16, _defs17, _g17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 359.2 108.5",
    style: {
      enableBackground: "new 0 0 359.2 108.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#070609;}\n\t.st2{clip-path:url(#SVGID_4_);}\n\t.st3{clip-path:url(#SVGID_6_);}\n\t.st4{clip-path:url(#SVGID_8_);}\n\t.st5{clip-path:url(#SVGID_10_);}\n\t.st6{clip-path:url(#SVGID_12_);}\n\t.st7{clip-path:url(#SVGID_14_);}\n\t.st8{clip-path:url(#SVGID_16_);}\n\t.st9{clip-path:url(#SVGID_18_);}\n\t.st10{clip-path:url(#SVGID_20_);}\n\t.st11{clip-path:url(#SVGID_22_);}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1D1B;}\n\t.st13{clip-path:url(#SVGID_24_);}\n\t.st14{fill:#1D1D1B;}\n\t.st15{clip-path:url(#SVGID_26_);}\n\t.st16{clip-path:url(#SVGID_28_);}\n\t.st17{clip-path:url(#SVGID_30_);}\n\t.st18{clip-path:url(#SVGID_32_);}\n\t.st19{clip-path:url(#SVGID_34_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 51,
    y: 86.5,
    width: 1.5,
    height: 10.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.3,
    y: 74.8,
    className: "st1",
    width: 24.8,
    height: 33.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_3_",
    points: "78.2,94 72.2,86.5 70.9,86.5 70.9,96.7 72.4,96.7 72.4,89 78.6,96.7 79.7,96.7 79.7,86.5  78.2,86.5 78.2,94  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.2,
    y: 74.8,
    className: "st1",
    width: 32.1,
    height: 33.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_5_",
    points: "97.3,87.9 100.7,87.9 100.7,96.7 102.2,96.7 102.2,87.9 105.5,87.9 105.5,86.5 97.3,86.5  97.3,87.9  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.7,
    y: 74.8,
    className: "st1",
    width: 31.6,
    height: 33.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_7_",
    points: "124.7,92.3 130.2,92.3 130.2,90.9 124.7,90.9 124.7,87.9 130.8,87.9 130.8,86.5 123.2,86.5  123.2,96.7 130.9,96.7 130.9,95.3 124.7,95.3 124.7,92.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 74.8,
    className: "st1",
    width: 31.1,
    height: 33.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M150.1,87.9h2.9c0.6,0,1.3,0.1,1.8,0.5c0.4,0.3,0.6,0.8,0.6,1.3c0,0.3,0,0.5-0.2,0.7 c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.7,0.1-1,0.1h-2.9L150.1,87.9z M155,92.3c0.4-0.1,0.7-0.4,1-0.6 c0.3-0.3,0.5-0.6,0.7-0.9c0.2-0.4,0.3-0.8,0.2-1.2c0-0.8-0.3-1.5-0.8-2c-0.4-0.3-0.8-0.6-1.3-0.8c-0.6-0.2-1.1-0.3-1.7-0.3h-4.4 v10.2h1.5v-3.9h2.6l3.1,3.9h1.9l-3.3-4.2C154.6,92.5,154.8,92.4,155,92.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.9,
    y: 74.8,
    className: "st1",
    width: 32.4,
    height: 33.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M177.2,92.7l1.9-4.2l1.9,4.2H177.2z M178.6,86.4l-4.8,10.2h1.6l1.2-2.7h5.2l1.2,2.7h1.7l-4.8-10.2 L178.6,86.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.1,
    y: 74.8,
    className: "st1",
    width: 34.2,
    height: 33.6
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M209.7,94.1c-0.4,0.4-0.9,0.7-1.4,1c-0.5,0.2-1.1,0.4-1.6,0.3c-0.5,0-1-0.1-1.4-0.3 c-0.4-0.2-0.8-0.5-1.2-0.8c-0.3-0.4-0.6-0.8-0.8-1.2c-0.2-0.5-0.3-1-0.3-1.6c0-0.5,0.1-1,0.3-1.5c0.2-0.5,0.4-0.9,0.8-1.2 c0.3-0.3,0.7-0.6,1.2-0.8c0.7-0.3,1.6-0.4,2.4-0.2c0.3,0.1,0.5,0.2,0.8,0.3c0.2,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.4,0.3,0.6,0.5 l0.3,0.3l1.1-1l-0.3-0.2c-0.3-0.2-0.5-0.4-0.8-0.6c-0.3-0.2-0.6-0.4-0.9-0.5c-0.3-0.2-0.7-0.3-1.1-0.3c-0.4-0.1-0.8-0.1-1.2-0.1 c-0.7,0-1.4,0.1-2.1,0.4c-0.6,0.3-1.2,0.7-1.6,1.1c-1.4,1.6-1.8,3.8-1,5.7c0.2,0.6,0.6,1.2,1.1,1.7c0.5,0.5,1,0.9,1.6,1.1 c0.7,0.3,1.4,0.4,2.1,0.4c0.4,0,0.8,0,1.3-0.1c0.7-0.2,1.4-0.5,2-0.9c0.3-0.2,0.6-0.5,0.8-0.7l0.3-0.3l-1-1L209.7,94.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.8,
    y: 74.7,
    className: "st1",
    width: 32.9,
    height: 33.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_15_",
    points: "227.6,87.9 231,87.9 231,96.7 232.5,96.7 232.5,87.9 235.8,87.9 235.8,86.5 227.6,86.5  227.6,87.9  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.9,
    y: 74.8,
    className: "st1",
    width: 31.6,
    height: 33.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 253.5,
    y: 86.5,
    width: 1.5,
    height: 10.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.9,
    y: 74.8,
    className: "st1",
    width: 24.9,
    height: 33.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_19_",
    points: "277.6,94.6 274.1,86.5 272.4,86.5 277,96.8 278.1,96.8 282.7,86.5 281.1,86.5 277.6,94.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.8,
    y: 74.8,
    className: "st1",
    width: 33.6,
    height: 33.6
  })))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_21_",
    points: "301.5,95.3 301.5,92.3 307,92.3 307,90.9 301.5,90.9 301.5,87.9 307.6,87.9 307.6,86.5 300,86.5  300,96.7 307.7,96.7 307.7,95.3 301.5,95.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.3,
    y: 74.8,
    className: "st1",
    width: 31.1,
    height: 33.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "b_red"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M208.4,12.5h-20.7V60h21.8c11.5,0,18-4.5,18-12.5v-0.1c0-5.7-4.3-10.2-10.9-11.7c5.1-1.7,8.2-5.8,8.2-11v-0.1 c0.1-3-1.1-5.9-3.3-8C218.8,13.9,214.2,12.5,208.4,12.5 M190.1,34.9V14.6h18.3c8.8,0,14.3,3.9,14.3,10.1v0.1 c0,7.5-6.8,10.1-13.1,10.1L190.1,34.9 M190.1,57.9V37h20.7c7.2,0,14.5,3.2,14.5,10.5v0.1c0,6.6-5.7,10.3-15.7,10.3L190.1,57.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M208.4,12.5h-20.7V60h21.8c11.5,0,18-4.5,18-12.5v-0.1c0-5.7-4.3-10.2-10.9-11.7c5.1-1.7,8.2-5.8,8.2-11 v-0.1c0.1-3-1.1-5.9-3.3-8C218.8,13.9,214.2,12.5,208.4,12.5 M190.1,34.9V14.6h18.3c8.8,0,14.3,3.9,14.3,10.1v0.1 c0,7.5-6.8,10.1-13.1,10.1L190.1,34.9 M190.1,57.9V37h20.7c7.2,0,14.5,3.2,14.5,10.5v0.1c0,6.6-5.7,10.3-15.7,10.3L190.1,57.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.1,
    y: 0.8,
    className: "st14",
    width: 63.2,
    height: 70.9
  }))))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_25_",
    points: "35.1,41.2 13.8,12.5 11.7,12.5 11.7,60 14,60 14,16.5 34.7,44.4 34.9,44.6 35.3,44.6 56.1,16.5  56.1,60 58.5,60 58.5,12.5 56.5,12.5 35.1,41.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.8,
    className: "st1",
    width: 70.1,
    height: 70.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    d: "M140.1,36.2v0.1c0,12.8-9.7,22.4-22.6,22.4c-12.4,0.2-22.5-9.7-22.7-22c0-0.1,0-0.3,0-0.4v-0.1 c0-12.7,9.7-22.4,22.6-22.4c12.4-0.2,22.5,9.7,22.7,22C140.1,35.9,140.1,36.1,140.1,36.2z M117.5,11.7c-14.2,0-25,10.5-25,24.5 v0.1c0,14,10.7,24.5,25,24.5s25-10.5,25-24.5v-0.1C142.5,22.2,131.7,11.7,117.5,11.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.8,
    className: "st1",
    width: 73.3,
    height: 72.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    d: "M179.6,37h20.7c7.2,0,14.5,3.2,14.5,10.5v0.1c0,6.6-5.7,10.3-15.7,10.3h-19.5V37z M179.6,34.9V14.6h18.3 c8.8,0,14.3,3.9,14.3,10.1v0.1c0,7.5-6.8,10.1-13.1,10.1H179.6z M206.3,35.7c5.1-1.7,8.2-5.7,8.2-11v-0.1c0.1-3-1.1-5.9-3.3-8 c-2.9-2.7-7.4-4.1-13.3-4.1h-20.7V60h21.8c11.5,0,18-4.5,18-12.5v-0.1C217.1,41.7,212.8,37.2,206.3,35.7L206.3,35.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.6,
    y: 0.8,
    className: "st1",
    width: 63.2,
    height: 70.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: 259.9,
    y: 12.5,
    width: 2.3,
    height: 47.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.2,
    y: 0.8,
    className: "st1",
    width: 25.7,
    height: 70.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "M345.2,36.2v0.1c0,12.8-9.7,22.4-22.6,22.4c-12.4,0.2-22.5-9.7-22.7-22c0-0.1,0-0.3,0-0.4v-0.1 c0-12.7,9.7-22.4,22.6-22.4c12.4-0.2,22.5,9.7,22.7,22C345.2,35.9,345.2,36.1,345.2,36.2z M322.6,11.7c-14.2,0-25,10.5-25,24.5 v0.1c0,14,10.7,24.5,25,24.5c14.3,0,25-10.5,25-24.5v-0.1C347.5,22.2,336.8,11.7,322.6,11.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.9,
    className: "st1",
    width: 73.3,
    height: 72.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiLogo);
export default __webpack_public_path__ + "static/media/MI_Logo.b7b4163e3cd2b25af39afde2aa803947.svg";
export { ForwardRef as ReactComponent };